import React from 'react';
import IconButton from '@mui/material/IconButton';
import { OpenIcon, CloseIcon } from '../Icons';
import MobilePrivateLoader from './MobilePrivateLoader';
import * as S from './styles';
const HamburgerSection = ({ mobilePanelDisplay, setMobilePanelDisplay, shouldShowPrivateLoader, }) => {
    const toggleMobilePanelHandler = () => {
        setMobilePanelDisplay(!mobilePanelDisplay);
    };
    if (shouldShowPrivateLoader) {
        return (React.createElement(S.Wrapper, null,
            React.createElement(MobilePrivateLoader, null)));
    }
    return (React.createElement(S.Wrapper, null,
        React.createElement(IconButton, { className: "iconButton", onClick: toggleMobilePanelHandler, role: "button" }, mobilePanelDisplay ? React.createElement(CloseIcon, null) : React.createElement(OpenIcon, null))));
};
export default HamburgerSection;
//# sourceMappingURL=index.js.map